<mat-nav-list class="sidenav-list" tabindex="0">
  <mat-card appearance="outlined" class="menu-header">
    @if (colorSchemeService.currentActive() === 'light' && !iconOnlyMode) {
    <img
      fetchpriority="high"
      class="single-logo"
      src="{{ clientInformation?.logo_path_light }}"
      (error)="logoErrorHandler($event)"
      alt="org-logo"
    />
    } @if (colorSchemeService.currentActive() === 'dark' && !iconOnlyMode) {
    <img
      fetchpriority="high"
      class="single-logo"
      src="{{ clientInformation?.logo_path_dark }}"
      (error)="logoErrorHandler($event)"
      alt="org-logo"
    />
    }

    <div class="side-menu__launchpad-rail">
      <mat-list-item
        class="dashboard__sidenav-list_item side-menu__list-item side-menu__list-item--core-root side-menu__launchpad-item menu-left-border mat-mdc-list-item-interactive"
        matRipple
        routerLink="/app/launchpad"
        [routerLinkActiveOptions]="activeMatchOptions"
        [routerLinkActive]="['side-menu__item--active']"
        (mwlClick)="onClickLaunchPad()"
        (contextmenu)="onLaunchpadContextMenu($event)"
      >
        <mat-icon
          matListItemIcon
          class="side-menu__item-icon mr-0"
          [fontSet]="launchpadIconFontSet()"
        >
          dashboard
        </mat-icon>
        @if (!iconOnlyMode) {
        <div
          matListItemTitle
          class="mat-mdc-list-item-gutters side-menu__item-label"
        >
          {{ 'pages.dashboard.side-menu.dashboard' | translate }}
        </div>
        }
      </mat-list-item>
    </div>

    <!-- ----------------------------- Side panel Search ----------------------------------- -->
    <mat-divider></mat-divider>
    @if (!iconOnlyMode) {
    <div
      class="no-padding pr-1 pl-1 d-flex my-0 justify-content-center side-menu__search-row"
    >
      <div class="side-menu-search-chip">
        <input
          [placeholder]="'pages.home.filter' | translate"
          [(ngModel)]="searchValue"
          type="text"
        />
        <div class="search-icons">
          <span matSuffix>
            <mat-icon class="prefix-icon">filter_list</mat-icon>
          </span>
          <button
            class="close-btn"
            aria-label="Clear"
            (click)="searchValue = ''"
            [ngClass]="{ show: searchValue }"
          >
            <mat-icon class="prefix-icon">close</mat-icon>
          </button>
        </div>
      </div>
    </div>
    } @if (!iconOnlyMode) {
    <mat-divider></mat-divider>
    }
  </mat-card>
  <div class="menu-container">
    <mat-list [ngClass]="{ 'menu-list': !iconOnlyMode }">
      <app-menu-items
        [iconOnlyMode]="iconOnlyMode"
        [menuItems]="menuItems"
        [searchValue]="searchValue"
        (onClicked)="itemSelect($event)"
        (onExpanded)="itemExpanded($event)"
      ></app-menu-items>
    </mat-list>
  </div>
  <div
    class="side-menu__nav-context-anchor"
    style="visibility: hidden; position: fixed"
    [style.left]="menuTopLeftPosition.x"
    [style.top]="menuTopLeftPosition.y"
    [matMenuTriggerFor]="launchpadNavContextMenu"
    #launchpadNavContextMenuTrigger
  ></div>
  <mat-menu #launchpadNavContextMenu="matMenu">
    <button mat-menu-item type="button" (click)="openLaunchpadLinkInNewTab()">
      <mat-icon>open_in_new</mat-icon>
      <span>{{ 'pages.dashboard.open-in-new-tab' | translate }}</span>
    </button>
  </mat-menu>
</mat-nav-list>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
